export const BusinessPipelineMock =[
  {
    "priority": 1,
    "name": "MIDC Nerul",
    "location": "Nerul Navi Mumbai",
    "type": "RCC",
    "area": "17000\n15000",
    "capex": 117,
    "opex": 57,
    "loiSigning": "Completed",
    "agreementSigning": "Target Closure 6th Feb",
    "tokenRelease": "Completed",
    "execution": "Ongoing",
    "leasing": "Delhivery - Potential Customer",
    "icApproved": "2026-02-01"
  },
  {
    "priority": 2,
    "name": "Navbharat Industrial Estate",
    "location": "Sewri South",
    "type": "Shed",
    "area": "14000\n14000",
    "capex": 186,
    "opex": 83,
    "loiSigning": "Completed",
    "agreementSigning": "Target Closure 6th Feb",
    "tokenRelease": "Under Process",
    "execution": "Ongoing",
    "leasing": "6500 termsheet under signing with Swiggy",
    "icApproved": "2026-03-01"
  },
  {
    "priority": 3,
    "name": "Kavesar",
    "location": "Thane",
    "type": "BTS",
    "area": "22000\n18000",
    "capex": 206,
    "opex": 27,
    "loiSigning": "Completed",
    "agreementSigning": "Target Closure 10th Feb",
    "tokenRelease": "Under Process",
    "execution": "Ongoing",
    "leasing": "BIG 7 - Potential Customer",
    "icApproved": "2026-04-01"
  },
  {
    "priority": 4,
    "name": "Mohan Studio",
    "location": "Andheri E",
    "type": "Shed",
    "area": "12000\n10000",
    "capex": 175,
    "opex": 74,
    "loiSigning": "Completed",
    "agreementSigning": "Target Closure 10th Feb",
    "tokenRelease": "Under Process",
    "execution": "Yet to start",
    "leasing": "Blinkit & Instamart - Potential Customer",
    "icApproved": "2026-03-01"
  },
  {
    "priority": 5,
    "name": "Bansal Estate",
    "location": "Chandivali Naka",
    "type": "Shed",
    "area": "18000\n12000",
    "capex": 173,
    "opex": 87,
    "loiSigning": "Completed",
    "agreementSigning": "Target Closure 10th Feb",
    "tokenRelease": "Completed",
    "execution": "Yet to start",
    "leasing": "No leads",
    "icApproved": "2026-03-01"
  },
  {
    "priority": 6,
    "name": "Nahur",
    "location": "Nahur East",
    "type": "BTS",
    "area": "20000\n18000",
    "capex": 217,
    "opex": 44,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Under Preparation",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "DHL Lead",
    "icApproved": "2026-04-01"
  },
  {
    "priority": 7,
    "name": "Kolshet",
    "location": "Thane",
    "type": "BTS",
    "area": "21000\n21000",
    "capex": 203,
    "opex": 81,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Under Preparation",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "Snabit - Potential Customer",
    "icApproved": "2026-04-01"
  },
  {
    "priority": 8,
    "name": "Prodocs",
    "location": "Marol",
    "type": "RCC",
    "area": "9800\n9800",
    "capex": 152,
    "opex": 71,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Under Preparation",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "Swiggy - Potential Customer; DMART Lead",
    "icApproved": "2026-03-01"
  },
  {
    "priority": 9,
    "name": "Charkop",
    "location": "Kandivali (W) North",
    "type": "RCC",
    "area": "10000\n10000",
    "capex": 125,
    "opex": 68,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Under Preparation",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "Nerolac Paints - Potential Customer",
    "icApproved": "2026-03-01"
  },
  {
    "priority": 10,
    "name": "Kamla Auto works",
    "location": "Chembur East",
    "type": "Shed",
    "area": "7500\n7500",
    "capex": 70,
    "opex": 33,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Under Preparation",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "Instamart - Potential Customer",
    "icApproved": "2026-04-01"
  },
  {
    "priority": 11,
    "name": "Nr Taloja toll",
    "location": "Taloja Navi Mumbai",
    "type": "BTS",
    "area": "14000\n12000",
    "capex": 164,
    "opex": 27,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Under Preparation",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "DP World - Potential Customer; Amazon - Potential Customer",
    "icApproved": "2026-04-01"
  },
  {
    "priority": 12,
    "name": "Nr Seepz",
    "location": "Andheri E",
    "type": "RCC",
    "area": "19000\n15000",
    "capex": 236,
    "opex": 128,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Under Preparation",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "DMART - Potential Customer",
    "icApproved": "2026-02-01"
  },
  {
    "priority": 13,
    "name": "Phoenix Market City",
    "location": "Kurla",
    "type": "RCC",
    "area": "15000\n15000",
    "capex": 153,
    "opex": 75,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Yet to start",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "No leads",
    "icApproved": "2026-03-01"
  },
  {
    "priority": 14,
    "name": "Sewri",
    "location": "Sewri South",
    "type": "Shed",
    "area": "11000\n11000",
    "capex": 115,
    "opex": 55,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Yet to start",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "No leads",
    "icApproved": "2026-03-01"
  },
  {
    "priority": 15,
    "name": "Taloja MIDC",
    "location": "Taloja",
    "type": "RCC",
    "area": "28000\n28000",
    "capex": 168,
    "opex": 65,
    "loiSigning": "Shared with Owner",
    "agreementSigning": "Yet to start",
    "tokenRelease": "Yet to start",
    "execution": "Yet to start",
    "leasing": "No leads",
    "icApproved": "2026-03-01"
  }
];